/**
 * Get currency symbol based on ISO 4217 3-digit currency code
 * @param currencyCode - ISO currency code (e.g., 'EUR', 'USD', 'CHF')
 * @returns Currency symbol or the currency code itself if not found
 */
export var getCurrencySymbol = function getCurrencySymbol(currencyCode) {
  if (!currencyCode) return '€';
  var currencySymbols = {
    EUR: '€',
    CHF: 'CHF ',
    GBP: '£',
    USD: '$',
    CAD: '$',
    CNY: '¥',
    SGD: 'S$'
  };
  var upperCode = currencyCode.toUpperCase();
  return currencySymbols[upperCode] || upperCode;
};